import {ChoiceList, ChoiceRow, ModalShell} from './ui/ModalShell';

/**
 * The first step of Auto Triggers: which order-book operation to run.
 *
 * `SETTLE` opens the auto-settle modal; every other key opens the order book
 * trigger pre-set to that status. Six identical buttons gave no clue which
 * was which, so each is now a row that says where it leads.
 */
const ACTIONS = [
  {
    key: 'SETTLE',
    label: 'Settle Orders',
    description: 'Settle every eligible pending order for chosen instruments.',
  },
  {
    key: 'OPEN',
    label: 'Open Orders',
    description: 'Run the order book trigger for open orders.',
  },
  {
    key: 'PENDING',
    label: 'Pend Orders',
    description: 'Run the order book trigger for pending orders.',
  },
  {
    key: 'RETRY',
    label: 'Retry Orders',
    description: 'Run the order book trigger for retried orders.',
  },
  {
    key: 'REJECTED',
    label: 'Reject Orders',
    description: 'Run the order book trigger for rejected orders.',
  },
  {
    key: 'EXPIRED',
    label: 'Expire Orders',
    description: 'Run the order book trigger for expired orders.',
  },
];

export const SettleOptionsModal = ({onSelect}) => (
  <ModalShell
    title="Auto triggers"
    subtitle="Choose the operation to run against the order book.">
    <ChoiceList>
      {ACTIONS.map(action => (
        <ChoiceRow
          key={action.key}
          label={action.label}
          description={action.description}
          onClick={() => onSelect(action.key)}
        />
      ))}
    </ChoiceList>
  </ModalShell>
);
